"use strict";

exports.__esModule = true;
exports.TimestampRangeSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TimestampSelectorPopover = require("./TimestampSelectorPopover");
var _Theme = require("../../Theme");
var _timeDefinitions = require("../../timeDefinitions");
var _excluded = ["selected", "separator", "onSelect"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Separator = _styledComponents["default"].em.withConfig({
  displayName: "TimestampRangeSelector__Separator",
  componentId: "sc-viexiy-0"
})(["color:", ";background:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";display:flex;padding-left:1rem;padding-right:1rem;align-items:center;justify-content:center;"], (0, _Theme.val)("SecondaryButtonColor"), (0, _Theme.val)("SecondaryButtonBackground"), (0, _Theme.val)("ButtonBorderColor"), (0, _Theme.val)("ButtonBorderColor"));

/**
 * Allows a user to select a range of timestamps from a calendar.
 */
var TimestampRangeSelector = exports.TimestampRangeSelector = /*#__PURE__*/function (_Component) {
  function TimestampRangeSelector() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleChangeStart = function (_ref) {
      var value = _ref[0];
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        selected = _this$props.selected;
      if (selected.length > 1) {
        return onSelect([value, selected[1]]);
      }
      return onSelect([value, new Date(Math.min(value.getTime() + (0, _timeDefinitions.getDaysMillis)(3), Date.now()))]);
    };
    _this.handleChangeEnd = function (_ref2) {
      var value = _ref2[0];
      var _this$props2 = _this.props,
        onSelect = _this$props2.onSelect,
        selected = _this$props2.selected;
      if (selected.length > 0) {
        return onSelect([selected[0], value]);
      }
      return onSelect([new Date(value.getTime() - (0, _timeDefinitions.getDaysMillis)(3)), value]);
    };
    return _this;
  }
  _inheritsLoose(TimestampRangeSelector, _Component);
  var _proto = TimestampRangeSelector.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props3 = this.props,
      selected = _this$props3.selected,
      separator = _this$props3.separator,
      onSelect = _this$props3.onSelect,
      extra = _objectWithoutPropertiesLoose(_this$props3, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TimestampSelectorPopover.TimestampSelectorPopover, {
      selected: selected.length > 0 ? [selected[0]] : [],
      onSelect: this.handleChangeStart
    }), /*#__PURE__*/_react["default"].createElement(Separator, null, separator || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TimestampRangeSelector.separator",
      defaultMessage: "to"
    })), /*#__PURE__*/_react["default"].createElement(_TimestampSelectorPopover.TimestampSelectorPopover, {
      selected: selected.length > 1 ? [selected[1]] : [],
      onSelect: this.handleChangeEnd
    }));
  };
  return TimestampRangeSelector;
}(_react.Component);